import { React, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';
import { TextInput, Checkbox, Box, Modal, Select } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useForm } from '@mantine/form';

import Navbar from '../Navbar/NavbarPublic';
import Footer from '../Footer/Footer';
import SyndicRectangleButton from '../../composents/Buttons/Syndic/RectangleButton/RectangleButtonMain';
import RectangleButtonDisabled from '../../composents/Buttons/All/RectangleButtonDisabled/RectangleButtonDisabled';

const SignUp = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [siretError, setSiretError] = useState(null);

    const [opened, { open, close }] = useDisclosure(false);
    
    const navigate = useNavigate();

    useEffect(()=>{
        window.scrollTo(0,0);
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
          };
      
        window.addEventListener('resize', handleResize);
        return () => {
        window.removeEventListener('resize', handleResize);
        };
    },[])

    const form = useForm({
        initialValues: {
            email: '',
            cieName: '',
            siret_nb: '',
            firstname: '',
            lastname: '',
            collectivite: false,
            reseau: '',
            reseauAutre: '',
            referralCode: '',
            cg: false,
            rgpd: false,
        },

        validate: {
            email : (value) => (
                value.length < 1
                ? 'Renseignez votre E-mail'
                : /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(value) 
                ? null 
                : 'E-mail non valide'
            ),
            cieName: (value) => (
                value.length < 1
                    ? "Renseignez le nom de l'entreprise"
                    : value.length > 100
                    ? "100 caractères max."
                    : null
                ),
            siret_nb: (value) => (
                value.length < 1
                    ? "Renseignez votre SIRET"
                    : !/^\d{14}$/.test(value)
                    ? "Le SIRET doit contenir exactement 14 chiffres"
                    : !(
                        value.split("").reverse().reduce((acc, digit, index) => {
                        let num = parseInt(digit, 10);
                        if (index % 2 === 1) {
                            num *= 2;
                            if (num > 9) num -= 9;
                        }
                        return acc + num;
                        }, 0) % 10 === 0
                    )
                    ? "SIRET invalide"
                    : null
                ),
            firstname : (value) => (
                value.length < 1 
                ? 'Renseignez votre prénom'
                : value.length > 50 
                ? '50 caractères max.'
                : null
            ),
            lastname : (value) => (
                value.length < 1
                ? 'Renseignez votre nom'
                : value.length > 50 
                ? '50 caractères max.' 
                : null
            ),
        },
    });

    const handleFormSubmit = async (values, _event) => {
        _event.preventDefault();
        if (isSubmitting) return;
        setIsSubmitting(true);
        setSiretError(null);
        try {
            const siretCheckResponse = await fetch("https://boldee-97d8d36af3bd.herokuapp.com/users/verify-siret", {
                method: "POST",
                body: JSON.stringify({ siret: values.siret_nb }),
                headers: { "Content-Type": "application/json" }
            });
            const siretCheckData = await siretCheckResponse.json();
            if (siretCheckResponse.ok && siretCheckData.exists === false) {
                setSiretError("Nous n'avons pas retrouvé ce numéro de SIRET. Vérifiez qu'il est correct avant de continuer.");
                setIsSubmitting(false);
                return;
            }

            const response = await fetch("https://boldee-97d8d36af3bd.herokuapp.com/users/signup", {
             // await fetch("http://localhost:5030/users/signup", {
            method: "POST",
                body: JSON.stringify({
                    email: values.email,
                    cieName : values.cieName,
                    siret_nb : values.siret_nb,
                    lastname: values.lastname,
                    firstname: values.firstname,
                    collectivite: values.collectivite,
                    reseau: values.reseau === 'Autres' ? values.reseauAutre : values.reseau,
                    referralCode: values.referralCode,
                    cg: values.cg,
                    rgpd: values.rgpd,
                }),
                headers: { "Content-Type": "application/json" }
            });
            if (response.ok) {
                open();
                setTimeout(() => { navigate('/'); }, 1000);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return(        
        <div>
            <Navbar/>
            {isMobile ? (
                <>
                    <div className="width90pCenter">
                        <div className="mrgT150"></div>
                        <p id="signUpTitle">Inscription</p>
                        <p id="loginSubtitle">Je suis déjà membre.  
                            <Link to="/app/login">
                                <span className="aReset bT underline mrgL7 bold">
                                    Me connecter
                                </span>
                            </Link></p>
                    </div>
                    <Box className='width90pCenter'>
                        <form onSubmit={form.onSubmit(handleFormSubmit)}>
                           <TextInput
                                withAsterisk
                                label="Email"
                                placeholder="votre@email.com"
                                {...form.getInputProps('email')}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                withAsterisk
                                label="Raison sociale"
                                placeholder="Nom"
                                {...form.getInputProps('cieName')}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                withAsterisk
                                label="Numéro SIRET"
                                placeholder="Ex : 12345678900012"
                                {...form.getInputProps('siret_nb')}
                                onChange={(e) => {
                                    form.setFieldValue('siret_nb', e.currentTarget.value.replace(/\s/g, ""));
                                    setSiretError(null);
                                }}
                                error={form.errors.siret_nb || siretError}
                            />
                            <div className="mrgB10"></div>

                            <Checkbox
                                mt="md"
                                label="Je représente une collectivité"
                                color="dark"
                                {...form.getInputProps('collectivite', { type: 'checkbox' })}
                            />
                            <div className="mrgB10"></div>

                            <Select
                                label="Sélectionner mon réseau"
                                placeholder="Sélectionnez"
                                data={[
                                    { value: 'Agir et Innover 94', label: 'Agir et Innover 94' },
                                    { value: "Entrepren'elles", label: "Entrepren'elles" },
                                    { value: 'Autres', label: 'Autres' },
                                    { value: 'Aucun', label: 'Aucun' },
                                ]}
                                {...form.getInputProps('reseau')}
                            />
                            <div className="mrgB10"></div>

                            {form.values.reseau === 'Autres' && (
                                <>
                                <TextInput
                                    placeholder="Précisez votre réseau"
                                    {...form.getInputProps('reseauAutre')}
                                />
                                <div className="mrgB10"></div>
                                </>
                            )}

                            <TextInput
                                withAsterisk
                                label="Votre Nom"
                                placeholder="Nom"
                                {...form.getInputProps('lastname')}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                withAsterisk
                                label="Votre Prénom"
                                placeholder="Prénom"
                                {...form.getInputProps('firstname')}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                label="Code parrainage"
                                placeholder="Code parrainage (facultatif)"
                                {...form.getInputProps('referralCode')}
                            />
                            <div className="mrgB10"></div>

                            <Checkbox
                                required
                                mt="md"
                                label="J’accepte les CGU et CGV"
                                color="dark"
                                {...form.getInputProps('cg', { type: 'checkbox' })}
                            />
                            <div className="mrgB10"></div>
                            
                            <Checkbox
                                required
                                mt="md"
                                label="J’ai pris connaissance de la politique de confidentialité" 
                                color="dark"
                                {...form.getInputProps('rgpd', { type: 'checkbox' })}
                            />

                            <div className="mrgB20"></div>
                            
                            {form.isDirty() && !isSubmitting
                                ?   <SyndicRectangleButton type="submit">
                                        Envoyer
                                    </SyndicRectangleButton>
                                :   <RectangleButtonDisabled>
                                        {isSubmitting ? "Envoi en cours..." : "Envoyer"}
                                    </RectangleButtonDisabled>
                            }
                           
                            {open
                                ?   <Modal
                                        centered
                                        size="auto"
                                        opened={opened}
                                        onClose={close}
                                        withCloseButton={false}>
                                        <p className=" txt15 txtCenter noMrgTB">
                                            Votre inscription a été enregistrée avec succès
                                        </p>
                                    </Modal> 
                                :   ""
                            }
                            <div className="mrgB150"></div>
                        </form>
                    </Box>
                </>
            ) : (
                <>
                    <div className="width90pCenter">
                        <div className="mrgT100"></div>
                        <p id="signUpTitle">Inscription</p>
                        <p id="loginSubtitle">Je suis déjà membre.  
                            <Link to="/app/login">
                                <span className="aReset bT underline mrgL7 bold">
                                    Me connecter
                                </span>
                            </Link></p>
                    </div>
                    <Box sx={{ maxWidth: 300 }} mx="auto">
                        <form onSubmit={form.onSubmit(handleFormSubmit)}>
                           
                            <TextInput
                                withAsterisk
                                label="Email"
                                placeholder="votre@email.com"
                                size="md"
                                {...form.getInputProps('email')}
                            />
                            <div className="mrgB10"></div>

                              <TextInput
                                withAsterisk
                                label="Raison sociale"
                                placeholder="Nom"
                                size="md"
                                {...form.getInputProps('cieName')}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                withAsterisk
                                label="Numéro SIRET"
                                placeholder="Ex : 12345678900012"
                                size="md"
                                {...form.getInputProps('siret_nb')}
                                onChange={(e) => {
                                    form.setFieldValue('siret_nb', e.currentTarget.value.replace(/\s/g, ""));
                                    setSiretError(null);
                                }}
                                error={form.errors.siret_nb || siretError}
                            />
                            <div className="mrgB10"></div>

                            <Checkbox
                                mt="md"
                                label="Je représente une collectivité"
                                color="dark"
                                size="md"
                                {...form.getInputProps('collectivite', { type: 'checkbox' })}
                            />
                            <div className="mrgB10"></div>

                            <Select
                                label="Sélectionner mon réseau"
                                placeholder="Sélectionnez"
                                size="md"
                                data={[
                                    { value: 'Agir et Innover 94', label: 'Agir et Innover 94' },
                                    { value: "Entrepren'elles", label: "Entrepren'elles" },
                                    { value: 'Autres', label: 'Autres' },
                                    { value: 'Aucun', label: 'Aucun' },
                                ]}
                                {...form.getInputProps('reseau')}
                            />
                            <div className="mrgB10"></div>

                            {form.values.reseau === 'Autres' && (
                                <>
                                <TextInput
                                    placeholder="Précisez votre réseau"
                                    size="md"
                                    {...form.getInputProps('reseauAutre')}
                                />
                                <div className="mrgB10"></div>
                                </>
                            )}

                            <TextInput
                                withAsterisk
                                label="Votre Nom"
                                placeholder="Nom"
                                size="md"
                                {...form.getInputProps('lastname')}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                withAsterisk
                                label="Votre Prénom"
                                placeholder="Prénom"
                                size="md"
                                {...form.getInputProps('firstname')}
                            />
                            <div className="mrgB10"></div>

                            <TextInput
                                label="Code parrainage"
                                placeholder="Code parrainage (facultatif)"
                                size="md"
                                {...form.getInputProps('referralCode')}
                            />
                            <div className="mrgB20"></div>

                            <Checkbox
                                required
                                mt="md"
                                label="J’accepte les CGU et CGV"
                                color="dark"
                                size="lg"
                                {...form.getInputProps('cg', { type: 'checkbox' })}
                            />

                            <div className="mrgB20"></div>
                            
                            <Checkbox
                                required
                                mt="md"
                                label="J’ai pris connaissance de la politique de confidentialité" 
                                color="dark"
                                size="lg"
                                {...form.getInputProps('rgpd', { type: 'checkbox' })}
                            />

                            <div className="mrgB30"></div>
                            
                            {form.isDirty() && !isSubmitting
                                ?   <SyndicRectangleButton type="submit">
                                        Envoyer
                                    </SyndicRectangleButton>
                                :   <RectangleButtonDisabled>
                                        {isSubmitting ? "Envoi en cours..." : "Envoyer"}
                                    </RectangleButtonDisabled>
                            }
                            {open  
                                ?   <Modal 
                                        centered
                                        size="auto"
                                        opened={opened}
                                        onClose={close}
                                        withCloseButton={false}>
                                        <p className=" txt20 txtCenter noMrgTB">
                                            Votre inscription a été enregistrée avec succès
                                        </p>
                                    </Modal> 
                                :   ""
                            }
                            <div className="mrgB150"></div>
                        </form>
                    </Box>
                </>
            )}    
            <Footer/>
        </div>
    );
}
export default SignUp;